"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadUtm = exports.saveUtm = void 0;
const has_1 = __importDefault(require("lodash/has"));
const ls = __importStar(require("local-storage"));
const DEFAULT_STORAGE_KEY = 'M2_UTM_DATA';
const MIGRATION_FIRST_AT_TS = Date.UTC(2025, 9, 31, 0, 0, 0, 0);
const VERSION = 1;
function parseStrictUtmFromQuery(query) {
    if (query.length === 0)
        return {};
    const params = new URLSearchParams(query);
    const utmKeys = ['source', 'medium', 'term', 'content'];
    const result = utmKeys.reduce((acc, key) => {
        const value = params.get(`utm_${key}`);
        if (value) {
            acc[key] = value;
        }
        return acc;
    }, {});
    const name = params.get('utm_campaign') || params.get('utm_name');
    if (name)
        result.name = name;
    return result;
}
function hasAnyParams(params) {
    return !!params && Object.keys(params).length > 0;
}
class UtmMultiton {
    constructor(storageKey) {
        this.storageKey = storageKey;
        this.isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
    }
    static get(storageKey) {
        const existing = UtmMultiton.instances[storageKey];
        if (existing)
            return existing;
        const created = new UtmMultiton(storageKey);
        UtmMultiton.instances[storageKey] = created;
        return created;
    }
    readStored() {
        try {
            const parsedUnknown = ls.get(this.storageKey);
            if (!parsedUnknown)
                return undefined;
            const migrated = this.migrate(parsedUnknown);
            if (migrated)
                this.writeStored(migrated);
            return migrated;
        }
        catch (_a) {
            return undefined;
        }
    }
    migrate(raw) {
        const hasVersion = (0, has_1.default)(raw, 'v') && typeof raw.v === 'number';
        const v = hasVersion ? raw.v : 0;
        if (v > VERSION)
            return undefined;
        if (v === 0) {
            const flat = raw;
            return {
                first: flat,
                last: flat,
                firstAt: MIGRATION_FIRST_AT_TS,
                lastAt: Date.now(),
                v: VERSION,
            };
        }
        return raw;
    }
    writeStored(next) {
        try {
            return (next === null || next === void 0 ? void 0 : next.v) <= VERSION ? !!ls.set(this.storageKey, next) : false;
        }
        catch (_a) {
            return false;
        }
    }
    save() {
        var _a, _b, _c;
        if (!this.isBrowser)
            return false;
        let lastRecord;
        const search = ((_a = window.location) === null || _a === void 0 ? void 0 : _a.search) || '';
        if (search) {
            const parsed = parseStrictUtmFromQuery(search);
            if (hasAnyParams(parsed))
                lastRecord = parsed;
        }
        if (!lastRecord)
            return false;
        const current = this.readStored();
        const now = Date.now();
        const next = {
            first: (_b = current === null || current === void 0 ? void 0 : current.first) !== null && _b !== void 0 ? _b : lastRecord,
            last: lastRecord,
            firstAt: (_c = current === null || current === void 0 ? void 0 : current.firstAt) !== null && _c !== void 0 ? _c : now,
            lastAt: now,
            v: VERSION,
        };
        return this.writeStored(next);
    }
    load() {
        var _a;
        if (!this.isBrowser)
            return;
        const fromLs = this.readStored();
        if (fromLs && (fromLs.first || fromLs.last))
            return fromLs;
        const search = ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.search) || '';
        if (search) {
            const parsed = parseStrictUtmFromQuery(search);
            if (hasAnyParams(parsed)) {
                return { last: parsed, lastAt: Date.now(), v: VERSION };
            }
        }
        return undefined;
    }
}
UtmMultiton.instances = {};
function saveUtm(storageKey = DEFAULT_STORAGE_KEY) {
    try {
        const instance = UtmMultiton.get(storageKey);
        instance.save();
        return instance;
    }
    catch (error) {
        return undefined;
    }
}
exports.saveUtm = saveUtm;
function loadUtm(storageKey = DEFAULT_STORAGE_KEY) {
    try {
        return UtmMultiton.get(storageKey).load();
    }
    catch (_a) {
        return undefined;
    }
}
exports.loadUtm = loadUtm;
//# sourceMappingURL=utm.js.map